/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Creating_MixdownInputs */



/**
* | output |
* | --- |
* | "Creating audio mixdown..." |
*
* @param {Audio_Description_Export_Status_Creating_MixdownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_creating_mixdown = /** @type {((inputs?: Audio_Description_Export_Status_Creating_MixdownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Creating_MixdownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Création du mixdown audio...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiomixdown wird erstellt...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione di un mixaggio audio...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание аудиомикса...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando una mezcla de audio...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("进行音频混音……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオミックスダウンを作成しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो मिक्सडाउन तैयार किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criando a mixagem de áudio...")
	return /** @type {LocalizedString} */ ("Creating audio mixdown...")
});